



















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Lots from '@/components/Lots.vue';
import ImagesProgram from '@/components/ImagesProgram.vue';
import ProgramInfos from '@/components/ProgramInfos.vue';
import { getProgram, getProgramDocsCommentAdmin } from '../api/api';
import Program from '../models/Program';
import Map from '@/components/Map.vue';
import Timeline from '@/components/Timeline.vue';
import moment from 'moment';
import DocumentsProgram from '@/components/DocumentsProgram.vue';
import ProgramDocument from '@/models/ProgramDocument';
import get from 'lodash/get';
import router from '@/router';

let program: Program | null = null;

async function getProgramForRouter(programID: string) {
    try {
        const { data } = await getProgram(+programID);
        return data;
    } catch (error) {
        console.warn(error, get(error, 'response.data.message'));
        return null;
    }
}

function getProgramName(value: Program | null) {
    if (value) {
        return value.name;
    }
    return null;
}

@Component({
    beforeRouteEnter: async (to, from, next) => {
        const { route } = router.resolve({
            name: 'programs',
        });
        to.meta.breadcrumb[1].url = route.fullPath;

        if (to.params.programID) {
            program = await getProgramForRouter(to.params.programID);

            if (program == null) {
                Vue.prototype.$vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: `Programme introuvable.`,
                });

                next({
                    name: 'programs',
                });
                return;
            } else {
                to.meta.breadcrumb[2].title = getProgramName(program);
            }
        }

        next();
    },
    beforeRouteUpdate: async (to, from, next) => {
        if (to.params.programID) {
            program = await getProgramForRouter(to.params.programID);
            to.meta.breadcrumb[2].title = getProgramName(program);
        }

        next();
    },
    components: {
        Lots,
        ImagesProgram,
        DocumentsProgram,
        ProgramInfos,
        Map,
        Timeline,
    },
})
export default class ProgramShow extends Vue {
    program: Program | null = program;
    docsCommentText: string = '';
   

    async mounted() {
        await this.loadDocsComment();
    }

    async fetch() {
        const dataProgram = await getProgram(+this.$route.params.programID);
        this.program = dataProgram.data;
    }

    async loadDocsComment() {
        try {
            const { data } = await getProgramDocsCommentAdmin(+this.$route.params.programID);
            if (data && data.docs_comment) {
                this.docsCommentText = data.docs_comment;
            }
        } catch (error) {
            console.error('Error loading docs comment:', error);
        }
    }

   

    get dates() {
        if (!this.program) {
            return [];
        }

        if(this.program.tax_system) {
          let taxSyst: string[] = this.program.tax_system;
          //@ts-ignore
          if (taxSyst.indexOf('Revente LMNP') !== -1 || 
          taxSyst.indexOf('Revente LMNP Tourisme') !== -1 ||
          taxSyst.indexOf('Revente LMNP Étudiant') !== -1 ||
          taxSyst.indexOf('Revente LMNP Sénior') !== -1 ||
          taxSyst.indexOf('Revente LMNP Rés') !== -1 ||
          taxSyst.indexOf('Revente LMNP EHPAD') !== -1
          ) {
            return [
              {
                name: 'livraison',
                date: Date.now()
              }
            ];
          } else {
            return [
              {
                name: 'PC purgé',
                date: this.program.date_building_permit_purged,
              },
              {
                name: 'Actable',
                date: this.program.date_actability,
              },
              {
                name: 'Démarrage des travaux',
                date: this.program.date_start_building,
              },
              {
                name: 'Fin des travaux',
                date: this.program.date_end_building,
              },
              {
                name: 'Livraison',
                date: this.program.date_delivery,
              },
            ];
          }
        }
    }

    get images() {
        if (!this.program) {
            return null;
        }

        return this.program.images;
    }

    get documents() {
        if (!this.program) {
            return null;
        }

        return this.program.documents;
    }
}
